import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { AccountService } from '@halo/services/account.service'
import { Container } from 'typescript-ioc/es5'
import { AccountDto } from '@halo/dtos/account.dto'
import { AccountDetailsWell } from '@halo/components/account-data-form/account-details-well'
import './style/account-data-form.scss'
import { UserService } from '@halo/services/user.service'
import { AccountServerWell } from '@halo/components/account-data-form/account-server-well'
import { AppState } from '@halo/stores/app.state'
import { AccountPromptWell } from '@halo/components/account-data-form/account-prompt-well'
import { AccountNotificationWell } from '@halo/components/account-data-form/account-notification-well'
import { AccountSendIntegrationsWell } from '@halo/components/account-data-form/account-send-integrations-well'

interface IAccountDataForm {
    className?: string
    accountId?: number
}

interface IAccountDataFormState {
    account?: AccountDto
}

export class AccountDataForm extends React.Component<IAccountDataForm, IAccountDataFormState> {
    protected appState: AppState
    protected accountService: AccountService
    protected userService: UserService

    public constructor(props: any) {
        super(props)

        this.appState = Container.get(AppState)
        this.accountService = Container.get(AccountService)
        this.userService = Container.get(UserService)

        this.state = {}

        if (props.accountId) {
            this.fetchRequestedAccount()
        }
    }

    public render() {
        return (
            <div className={classnames('adf', this.props.className)}>
                <div className={classnames('adf-wrapper')}>
                    <AccountDetailsWell
                        loading={this.isLoading}
                        account={this.state.account}
                        onAccountUpdated={this.handleAccountUpdated}
                    />

                    <AccountServerWell
                        loading={this.isLoading}
                        account={this.state.account}
                        onAccountUpdated={this.handleAccountUpdated}
                    />

                    <AccountSendIntegrationsWell
                        loading={this.isLoading}
                        account={this.state.account}
                        onAccountUpdated={this.handleAccountUpdated}
                    />

                    <AccountNotificationWell
                        loading={this.isLoading}
                        account={this.state.account}
                        onAccountUpdated={this.handleAccountUpdated}
                    />

                    <AccountPromptWell
                        loading={this.isLoading}
                        account={this.state.account}
                        onAccountUpdated={this.handleAccountUpdated}
                    />
                </div>
            </div>
        )
    }

    protected get isLoading(): boolean {
        return !this.state.account
    }

    protected handleAccountUpdated = async (updates: Partial<AccountDto>) => {
        this.setState(({ account }) => ({
            account: {
                ...account,
                ...updates,
            } as AccountDto,
        }))
    }

    protected async fetchRequestedAccount() {
        const account = await this.accountService.fetchById(this.props.accountId, {}, false)

        this.setState({ account })
    }
}
